import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoVinculacionMinimo } from '../_models/producto-vinculacion-minimo';
import {ProductoVinculacionMinimoReferencia} from '../_models/producto-vinculacion-minimo-referencia';

@Injectable({
  providedIn: 'root'
})
export class ProductoVinculacionMinimoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosVinculacionesMinimo/';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoVinculacionMinimo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as ProductoVinculacionMinimo[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto ).pipe( map( res => res as ProductoVinculacionMinimo[] ) );
  }

  listadoPorProductoTodos( idProducto: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto + '/all' ).pipe( map( res => res as ProductoVinculacionMinimo[] ) );
  }


  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + id ).pipe( map( res => res as ProductoVinculacionMinimo ) );
  }

  crear( regCrear: ProductoVinculacionMinimo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoVinculacionMinimo ) );
  }

  actualizar( regActualizar: ProductoVinculacionMinimo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  listadoPorProductoAnalizamos( idProducto: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto + '/analizamos'  ).pipe( map( res => res as ProductoVinculacionMinimo[] ) );
  }

  listadoPorProductoConTipoPersonaAnalizamos( idProducto: string , idTipoPersona: string) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto +'/tipoPersona/'+ idTipoPersona + '/analizamos'  ).pipe( map( res => res as ProductoVinculacionMinimo[] ) );
  }

  listadoPorProductoDigital( idProducto: string ) {
    return this.httClient.get( this.rutServicio + 'producto/' + idProducto + '/digital' ).pipe( map( res => res as ProductoVinculacionMinimo[] ) );
  }

}
